// Token management service
// This module provides a way for non-React code to access Auth0 tokens

let auth0Client = null;
let cachedUser = null;

/**
 * Set the Auth0 client and user - called from AuthTokenProvider
 */
export function setAuth0Client(getAccessTokenSilently, user) {
  auth0Client = getAccessTokenSilently;
  cachedUser = user;
}

/**
 * Get a valid token using the Auth0 SDK
 * @returns {Promise<Object>} The token data with accessToken, sub, and email
 */
export async function getValidToken() {
  if (!auth0Client) {
    throw new Error('Auth0 client not initialized. Make sure AuthTokenProvider is mounted.');
  }
  
  try {
    const accessToken = await auth0Client();
    
    return {
      accessToken,
      sub: cachedUser?.sub || '',
      email: cachedUser?.email || ''
    };
  } catch (error) {
    console.error('Token refresh error:', error);
    throw error;
  }
}

/**
 * Clear the token cache on logout
 */
export function clearTokenCache() {
  auth0Client = null;
  cachedUser = null;
}
